/* eslint-disable no-param-reassign */
import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, Link, useHistory } from 'react-router-dom';
import clsx from 'clsx';
// core
import {
  Button,
  Divider,
  FormControlLabel,
  Switch,
  IconButton,
  Grid,
  TextField,
  CircularProgress,
  Box,
} from '@material-ui/core';

import {
  DragIndicator,
  Edit,
  ExpandLess,
  ExpandMore,
  VisibilityOutlined,
  ReplyOutlined,
} from '@material-ui/icons';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {
  getSurveys,
  editSurvey,
  getSurveysByType,
} from '../../../../requests/api/survey';

import useStyles from './styles';
import { CategoryOptionsProvider } from '../../../../components/Pages/QuestionShell/CategoryOptionsContext';

// const
import {
  DROP_DOWN_MENU,
  END_PAGE,
  LONG_ANSWER,
  SIMPLE_SELECTION,
  SATISFACTION,
  SHORT_ANSWER,
  MULTIPLE_SELECTION,
  WELCOME_PAGE,
  YES_NO_QUESTION,
  NUMERIC_ANSWER,
  DATE,
  NPS_QUESTION,
  CONTENT,
  MULTIPLE_IMAGE_QUESTION,
  SIGNATURE_QUESTION,
  BARCODE_QUESTION,
  RESUME_PAGE,
  DECIMAL_ANSWER,
  PRICE,
  VIDEO,
  TIME,
  FORMATTED_ANSWER,
  USER_SELECTION,
} from '../../../../utils/const/pageTypes';

import { EDIT_MODE } from '../../../../utils/const/taskModes';

import questionValidator from '../../../../utils/questionsValidator';
import {
  remapIdentifierAfterDelete,
  normalizeQuestionLogic,
  removeQuestionAndRewireLogic,
} from '../../../../utils/questionLogic';
import { AUDIO, AUDIO_BACKGROUND, IMAGE } from '../../../../utils/const/questions';
import { NONE, PRICE as PRICE_KPI, isShareKpiType } from '../../../../utils/const/teleaudit';

import SelectPage from '../../../../components/Pages/SelectPage';
import WelcomePage from '../../../../components/Pages/WelcomePage';
import SimpleSelection from '../../../../components/Pages/SimpleSelection';
import MultipleSelection from '../../../../components/Pages/MultipleSelection';
import UserSelection from '../../../../components/Pages/UserSelection';
import ShortAnswer from '../../../../components/Pages/ShortAnswer';
import DropDownMenu from '../../../../components/Pages/DropDownMenu';
import LongAnswer from '../../../../components/Pages/LongAnswer';
import Satisfaction from '../../../../components/Pages/Satisfaction';
import ImagesAnswer from '../../../../components/Pages/ImageAnswer';
import NumericAnswer from '../../../../components/Pages/NumericAnswer';
import Snackbar from '../../../../components/Snackbar';
import DateAnswer from '../../../../components/Pages/DateAnswer';
import QuestionLogic from '../../../QuestionLogic';
import YesNoQuestion from '../../../../components/Pages/YesNoQuestion';
import NpsQuestion from '../../../../components/Pages/NpsQuestion';
import MultipleImageQuestion from '../../../../components/Pages/MultipleImageQuestion';
import SignatureQuestion from '../../../../components/Pages/SignatureQuestion';
import BarcodeQuestion from '../../../../components/Pages/BarcodeQuestion';
import DecimalAnswer from '../../../../components/Pages/DecimalAnswer';
import ResumePage from '../../../../components/Pages/ResumePage';
import Price from '../../../../components/Pages/Price';
import TaskSettings from '../../TaskSettings';
import Video from '../../../../components/Pages/Video';
import Audio from '../../../../components/Pages/Audio';
import Time from '../../../../components/Pages/Time';
import { getTask } from '../../../../requests/api/task';
import {
  getQuestionGuidelinesList,
  createQuestionGuideline,
  updateQuestionGuideline,
  deleteQuestionGuideline,
} from '../../../../requests/api/question-guideline';
import FormattedAnswer from '../../../../components/Pages/FormattedAnswer';

function TaskEdit() {
  const { taskId } = useParams();
  const styles = useStyles();
  const { t } = useTranslation();
  const taskURLPath = '/tasks';
  const history = useHistory();
  const [formType, setFormType] = useState({ name: '', value: '' });
  const [verticalForm, setVerticalForm] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [openSettingsDialog, setOpenSettingsDialog] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [title, setTitle] = useState(null);
  const [project, setProject] = useState(null);
  const [taskInfo, setTaskInfo] = useState({
    project: '',
    title: '',
    type: '',
    requiredGeoreference: false,
    revisionPolicy: '',
    surveyTeleaudit: 0,
    needReview: '',
    executionSurveyId: null,
    reviewSurveyId: '',
    aiAnalysisRequired: false,
  });

  const [executionSurveyId, setExecutionSurveyId] = useState({
    name: '',
    value: null,
  });
  const [reviewSurveyId, setReviewSurveyId] = useState({
    name: '',
    value: null,
  });
  const [executionSurveyOptions, setExecutionSurveyOptions] = useState([]);
  const [reviewSurveyOptions, setReviewSurveyOptions] = useState([]);
  const [values, setValues] = useState({
    title,
    formType: taskInfo.type,
    project,
    questions: [],
    isSwitchStock: false,
    productInformation: false,
  });
  const [georeference, setGeoreference] = useState(
    taskInfo.requiredGeoreference,
  );
  const [aiAnalysisRequired, setAiAnalysisRequired] = useState(
    taskInfo.aiAnalysisRequired,
  );
  const [viewDetail, setViewDetail] = useState(null);
  const generalView = false;
  const [switchStock, setSwitchStock] = useState(null);
  const [needReview, setNeedReview] = useState({
    name: t('task.taskEdition.revisionPolicy.placeholder'),
    value: '',
  });

  const [surveyLabel, setSurveyLabel] = useState({
    name: t('task.taskForm.withoutLabel'),
    value: '',
  });

  const [pages, setPages] = useState([
    {
      identifier: 0,
      type: null,
      name: '',
      required: false,
    },
  ]);
  const [selectedPage, setSelectedPage] = useState(null);
  const [openConnections, setOpenConnections] = useState(false);
  const [maxDistance, setMaxDistance] = useState(taskInfo.maxDistance ?? 0);
  const [deletedQuestions, setDeletedQuestions] = useState([]);
  const [teleauditQuestionOptions, setTeleauditQuestionOptions] = useState([]);
  const [revisionPolicy, setRevisionPolicy] = useState({
    name: t('task.taskEdition.revisionPolicy.placeholder'),
    value: '',
  });

  const [isSurveyTeleaudit, setIsSurveyTeleaudit] = useState({
    name: t('task.taskEdition.revisionPolicy.placeholder'),
    value: '',
  });

  useEffect(() => {
    const getTaskById = async () => {
      const executionResponse = await getSurveysByType('execution');
      const reviewResponse = await getSurveysByType('review');
      const executionOptions = [
        { name: 'Seleccione Encuesta de Ejecución', value: null },
        ...(executionResponse.data?.data?.surveys || []).map((survey) => ({
          name: survey.title,
          value: survey.id,
        })),
      ];

      const reviewOptions = [
        { name: 'Seleccione Encuesta de Revisión', value: null },
        ...(reviewResponse.data?.data?.surveys || []).map((survey) => ({
          name: survey.title,
          value: survey.id,
        })),
      ];

      setExecutionSurveyOptions([...executionOptions]);
      setReviewSurveyOptions([...reviewOptions]);
      const { data, success } = await getTask(taskId);
      if (success) {
        const taskData = data.data.task;
        setProject({ ...data.data.task.Project });
        setTaskInfo({
          title: taskData.title,
          project: taskData.Project.id,
          type: { name: taskData.type },
          requiredGeoreference: taskData.requiredGeoreference,
          revisionPolicy: taskData.revisionPolicy,
          label: taskData.label,
          surveyTeleaudit: taskData.surveyTeleaudit ? 'yes' : 'no',
          maxDistance: taskData.maxDistance,
          needReview: taskData.needReview,
          executionSurveyId: taskData.executionSurveyId,
          reviewSurveyId: taskData.reviewSurveyId,
          aiAnalysisRequired: taskData.aiAnalysisRequired,
        });

        setFormType({ name: taskData.type, value: taskData.type });
        setVerticalForm(taskData.vertical);
        setTitle(taskData.title);
        if (taskData.Questions.length > 0) {
          const sortedQuestions = taskData.Questions.sort(
            (a, b) => a.position - b.position,
          );

          const aiQuestions = sortedQuestions.filter(
            (question) => question.aiAnalysisRequired
              && [IMAGE, MULTIPLE_IMAGE_QUESTION].includes(question.type),
          );

          const guidelinesByQuestionId = {};
          if (aiQuestions.length > 0) {
            await Promise.all(aiQuestions.map(async (question) => {
              const guidelinesResponse = await getQuestionGuidelinesList({
                questionId: question.id,
              });
              const [guideline] = guidelinesResponse.success
                ? guidelinesResponse.data.data.questionGuidelinesList
                : [];
              if (guideline) {
                guidelinesByQuestionId[question.id] = guideline;
              }
            }));
          }

          const questionsWithGuidelines = sortedQuestions.map((question) => {
            const guideline = guidelinesByQuestionId[question.id];
            return guideline
              ? {
                ...question,
                questionGuidelineId: guideline.id,
                guideline: guideline.guideline,
                nMinPictures: guideline.nMinPictures,
              }
              : question;
          });

          setQuestions(questionsWithGuidelines);
        }
      }
    };

    if (taskId) {
      getTaskById();
    }
  }, [taskId]);

  useEffect(() => {
    const requestSearch = async () => {
      const response = await getSurveys();
      if (response.success) {
        const options = [
          { name: 'Seleccione Opcion', value: '' },
          ...response.data.data.surveys.map((survey) => ({
            name: survey.title,
            value: survey.id,
          })),
        ];
        setTeleauditQuestionOptions(options);
      }
    };
    requestSearch();
  }, []);

  useEffect(() => {
    setGeoreference(taskInfo.requiredGeoreference);
    setAiAnalysisRequired(taskInfo.aiAnalysisRequired);
    setMaxDistance(taskInfo.maxDistance);
    setRevisionPolicy({
      name: t('task.taskEdition.revisionPolicy.placeholder'),
      value: taskInfo.revisionPolicy,
    });
    setNeedReview({
      name: t('task.taskEdition.revisionPolicy.placeholder'),
      value: taskInfo.needReview,
    });
    setExecutionSurveyId({
      name: t('task.taskEdition.revisionPolicy.placeholder'),
      value: taskInfo.executionSurveyId,
    });
    setReviewSurveyId({
      name: t('task.taskEdition.revisionPolicy.placeholder'),
      value: taskInfo.reviewSurveyId,
    });
    setSurveyLabel({
      name: t('task.taskForm.withoutLabel'),
      value: taskInfo.label,
    });
    setIsSurveyTeleaudit({
      name: t('task.taskEdition.revisionPolicy.placeholder'),
      value: taskInfo.surveyTeleaudit,
    });
  }, [
    taskInfo.requiredGeoreference,
    taskInfo.aiAnalysisRequired,
    taskInfo.maxDistance,
    taskInfo.needReview,
    taskInfo.revisionPolicy,
    taskInfo.label,
    taskInfo.surveyTeleaudit,
    t,
    taskInfo.executionSurveyId,
    taskInfo.reviewSurveyId,
  ]);

  useEffect(() => {
    const hasSwitchStockQuestion = pages.find((page) => page.isSwitchStock);
    if (hasSwitchStockQuestion) {
      setSwitchStock(hasSwitchStockQuestion.identifier);
      setValues((prevValues) => ({
        ...prevValues,
        isSwitchStock: true,
      }));
    }
  }, [pages]);

  const parseQuestionChoices = useCallback(
    (questionChoices) => questionChoices.map((choice, index) => ({
      title: choice.title,
      type: choice.type,
      identifier: index + 1,
      id: choice.id,
      position: choice.position,
    })),
    [],
  );

  useEffect(() => {
    const newPages = questions.map((question, index) => {
      const [memoryQuantity, memoryUnit] = question.minMemory
        ? question.minMemory.split(' ')
        : [null, null];
      const isImageType = [IMAGE, MULTIPLE_IMAGE_QUESTION].includes(
        question.type,
      );

      const teleauditKpis = isImageType ? question.TeleauditKpis || [] : [];
      const kpiDetailsPage = teleauditKpis
        .filter((teleauditKpi) => !isShareKpiType(teleauditKpi.KpiDetail.teleauditType)
          && teleauditKpi.KpiDetail.teleauditType !== PRICE_KPI)
        .map((teleauditKpi) => ({
          // Id del KPI en base: sin esto el API crea uno nuevo en cada guardado.
          id: teleauditKpi.id,
          title: teleauditKpi.KpiDetail.name,
          description: teleauditKpi.KpiDetail.description,
          teleauditType: teleauditKpi.KpiDetail.teleauditType,
          image: teleauditKpi.KpiDetail.imageUrl || '',
        }));

      const shareKpi = teleauditKpis.reduce((acc, teleauditKpi) => {
        if (isShareKpiType(teleauditKpi.KpiDetail.teleauditType)) {
          acc.teleauditType = teleauditKpi.KpiDetail.teleauditType;
          acc.target = teleauditKpi.KpiDetail.target;
        }
        return acc;
      }, {});

      const priceKpi = {
        teleauditType: teleauditKpis.some(
          (teleauditKpi) => teleauditKpi.KpiDetail.teleauditType === PRICE_KPI,
        ) ? PRICE_KPI : NONE,
      };
      const sortedQuestionChoices = question.QuestionChoices
        ? [...question.QuestionChoices].sort(
          (a, b) => (a.position ?? 0) - (b.position ?? 0),
        )
        : [];
      const parseQuestionLogic = question.OriginalQuestionLogics.length > 0
        ? question.OriginalQuestionLogics.map((logic) => {
          const nextId = questions.findIndex(
            (q) => q.id === parseInt(logic.nextQuestionId, 10),
          );
          const questionChoiceIdentifier = sortedQuestionChoices.findIndex(
            (choice) => choice.id === logic.questionChoiceId,
          );
          return {
            questionIdentifier: `${index + 1}`,
            questionChoiceIdentifier:
                  questionChoiceIdentifier > -1
                    ? `${questionChoiceIdentifier + 1}`
                    : null,
            nextQuestionIdentifier:
                  nextId > -1 ? questions[nextId].position.toString() : 'end',
          };
        })
        // Sin conexiones guardadas, la pregunta sigue el orden de la encuesta.
        // Antes el default apuntaba a `questions.length + 1`, que está fuera de
        // rango: al guardar, cualquier pregunta del medio terminaba la encuesta.
        : [
          {
            questionIdentifier: `${index + 1}`,
            questionChoiceIdentifier: null,
            nextQuestionIdentifier: `${index + 2}`,
          },
        ];

      return {
        ...pages[index],
        identifier: `${index + 1}`,
        executor: question.executor || false,
        reviewer: question.reviewer || false,
        userProject: question.userProject || false,
        type: question.type,
        categoryId: question.categoryId ?? null,
        title: question.title,
        shortQuestion: question.shortQuestion || null,
        description: question.description,
        name: question.type,
        emojiScale: question.emojiScale || null,
        emojiSet: question.emojiSet || null,
        imageKey: question.imageKey || null,
        imageQuality: question.imageQuality || null,
        imageUrl: question.imageUrl || null,
        imageUrlExpiration: question.imageUrlExpiration || null,
        isSwitchStock: question.isSwitchStock || false,
        correctQuestionChoices: question.CorrectQuestionChoices || null,
        questionChoices: sortedQuestionChoices.length
          ? parseQuestionChoices(sortedQuestionChoices)
          : null,
        binaryKpis: kpiDetailsPage,
        sendEmail: question.sendEmail || false,
        questionEmails: question.QuestionEmails || null,
        required: question.required || false,
        shareKpi,
        priceKpi,
        questionLogic: parseQuestionLogic,
        requiresTeleaudit: question.requiresTeleaudit || false,
        aiAnalysisRequired: question.aiAnalysisRequired || false,
        guideline: question.guideline || '',
        nMinPictures: question.nMinPictures ?? 1,
        questionGuidelineId: question.questionGuidelineId || null,
        databaseId: question.id || null,
        memoryQuantity,
        memoryUnit,
        videoQuality: question.videoQuality || null,
        surveyTeleauditId: question.surveyTeleauditId || null,
        format: question.format || null,
        formatDescription: question.formatDescription || null,
      };
    });

    setPages([...newPages]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, parseQuestionChoices]);

  const handleSelectPage = useCallback((event) => {
    const [type, identifier] = event.currentTarget.id.split('-');
    if (type === 'null') return;
    setSelectedPage(identifier);
  }, []);

  const handleAddSection = useCallback(() => {
    const lastPage = pages[pages.length - 1];
    lastPage.questionLogic[
      lastPage.questionLogic.length - 1
    ].nextQuestionIdentifier = `${pages.length + 1}`;

    const newQuestion = {
      identifier: `${pages.length + 1}`,
      type: null,
      questionLogic: [
        {
          questionIdentifier: `${pages.length + 1}`,
          questionChoiceIdentifier: null,
          nextQuestionIdentifier: null,
        },
      ],
      required: false,
      databaseId: null,
    };

    setPages((prevPages) => [...prevPages, newQuestion]);
  }, [pages]);

  const handleSwitch = useCallback(
    (event) => {
      const { name, checked } = event.target;

      pages[name].required = checked;
    },
    [pages],
  );

  const onDragEnd = useCallback(
    ({ destination, source }) => {
      if (!destination) return;
      const copiedItems = [...pages];
      for (let i = 0; i < copiedItems.length; i += 1) {
        copiedItems[i].hiddenIdentifier = `${i + 1}`;
      }
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);

      for (let j = 0; j < copiedItems.length; j += 1) {
        // Updates identifier question, ignore informative pages
        copiedItems[j].identifier = `${j + 1}`;

        const questionLogicCopiedItem = copiedItems[j].questionLogic;
        if (questionLogicCopiedItem) {
          for (let i = 0; i < questionLogicCopiedItem.length; i += 1) {
            if (questionLogicCopiedItem[i].questionChoiceIdentifier) {
              const newIdToNextQuestion = copiedItems.find(
                (ci) => ci.hiddenIdentifier
                  === questionLogicCopiedItem[i].nextQuestionIdentifier,
              );
              const idQuestion = copiedItems.find(
                (ci) => ci.hiddenIdentifier
                  === questionLogicCopiedItem[i].questionIdentifier,
              );

              if (newIdToNextQuestion && idQuestion) {
                // eslint-disable-next-line max-len
                copiedItems[j].questionLogic[i].nextQuestionIdentifier = newIdToNextQuestion.identifier;
                copiedItems[j].questionLogic[i].questionIdentifier = idQuestion.identifier;
              }
            } else {
              copiedItems[j].questionLogic[i].questionIdentifier = `${j + 1}`;
              copiedItems[j].questionLogic[i].nextQuestionIdentifier = `${j + 2}`;
            }
          }
        }

        if (copiedItems[j].questionChoices) {
          // Ensure questionChoices are sorted by identifier
          copiedItems[j].questionChoices = copiedItems[j].questionChoices.sort(
            (a, b) => a.identifier - b.identifier,
          );
        }
      }

      const switchStockIndex = copiedItems.findIndex((ci) => ci.isSwitchStock);

      if (switchStockIndex !== -1) {
        setSwitchStock(copiedItems[switchStockIndex].identifier, 10);
      }
      copiedItems.forEach((copiedItem) => {
        delete copiedItem.hiddenIdentifier;
      });
      setPages([...copiedItems]);
    },
    [pages],
  );

  const saveQuestionGuidelines = useCallback(async () => {
    const guidelinePages = pages
      .map((page, index) => ({ ...page, position: index + 1 }))
      .filter(
        (page) => [IMAGE, MULTIPLE_IMAGE_QUESTION].includes(page.type)
          && (page.aiAnalysisRequired || page.questionGuidelineId),
      );

    if (guidelinePages.length === 0) return;

    const refreshedTask = await getTask(taskId);
    if (!refreshedTask.success) return;

    const refreshedQuestions = refreshedTask.data.data.task.Questions;

    await Promise.all(guidelinePages.map(async (page) => {
      const matchedQuestion = refreshedQuestions.find(
        (q) => q.position === page.position,
      );
      if (!matchedQuestion) return;

      if (page.aiAnalysisRequired) {
        // A single-image question can only ever capture one picture.
        const nMinPictures = page.type === IMAGE ? 1 : page.nMinPictures;
        if (page.questionGuidelineId) {
          await updateQuestionGuideline(page.questionGuidelineId, {
            questionId: matchedQuestion.id,
            guideline: page.guideline,
            nMinPictures,
          });
        } else {
          await createQuestionGuideline({
            questionId: matchedQuestion.id,
            guideline: page.guideline,
            nMinPictures,
          });
        }
      } else if (page.questionGuidelineId) {
        await deleteQuestionGuideline(page.questionGuidelineId);
      }
    }));
  }, [pages, taskId]);

  const handleSaveSurvey = async () => {
    const isInvalidMaxDistance = georeference
      && (maxDistance === ''
        || maxDistance === null
        || Number.isNaN(Number(maxDistance))
        || Number(maxDistance) < 0);
    if (isInvalidMaxDistance) {
      setSeverity('error');
      setMessage(t('task.saveErrors.maxDistanceInvalid'));
      return;
    }

    const maxDistanceToSave = georeference ? Number.parseInt(maxDistance, 10) : null;
    let revisionPolicyValidator = revisionPolicy.value;
    if (!revisionPolicyValidator) {
      setSeverity('error');
      setMessage(t('task.saveErrors.noRequiresRevision'));
      return;
    }

    if (values.isSwitchStock && switchStock == null) {
      setSeverity('error');
      setMessage(t('task.saveErrors.switchStockRequiredQuestion'));
      return;
    }

    const missingGuidelineIndex = pages.findIndex(
      (page) => [IMAGE, MULTIPLE_IMAGE_QUESTION].includes(page.type)
        && page.aiAnalysisRequired
        && !page.guideline?.trim(),
    );
    if (missingGuidelineIndex !== -1) {
      setSeverity('error');
      setMessage(`${t('task.saveErrors.aiAnalysisGuidelineRequired')} ${missingGuidelineIndex + 1}`);
      return;
    }

    const longGuidelineIndex = pages.findIndex(
      (page) => [IMAGE, MULTIPLE_IMAGE_QUESTION].includes(page.type)
        && page.aiAnalysisRequired
        && page.guideline?.trim().length > 255,
    );
    if (longGuidelineIndex !== -1) {
      setSeverity('error');
      setMessage(`${t('task.saveErrors.aiAnalysisGuidelineTooLong')} ${longGuidelineIndex + 1}`);
      return;
    }

    const newQuestionsArray = [];

    let position = 0;
    let validator = 0;
    pages.forEach(async (page) => {
      if (validator !== 0) return;
      position += 1;
      if (!page.type) return;

      if (page.databaseId) {
        const updatedQuestion = {
          questionId: page.databaseId,
          identifier: page.identifier,
          surveyId: taskId,
          categoryId: page.categoryId ?? null,
          title: page.title,
          shortQuestion: page.shortQuestion || null,
          description: page.description,
          type: page.type,
          imageKey: page.imageKey,
          imageQuality: page.imageQuality,
          required: page.required,
          deleted: page.deleted,
          emojiScale: page.emojiScale,
          emojiSet: page.emojiSet,
          requiresTeleaudit: page.requiresTeleaudit,
          aiAnalysisRequired: page.aiAnalysisRequired || false,
          imageUrl: page.imageUrl,
          sendEmail: page.sendEmail,
          questionEmails: page.questionEmails,
          position,
          questionLogic: normalizeQuestionLogic(page.questionLogic),
          questionAnswer: page.questionAnswer || null,
          questionChoices: page.questionChoices || null,
          isSwitchStock: page.identifier === switchStock,
          minMemory:
            page.memoryQuantity && page.memoryUnit
              ? `${page.memoryQuantity} ${page.memoryUnit}`
              : null,
          videoQuality: page.videoQuality || null,
          surveyTeleauditId: page.surveyTeleauditId || null,
          binaryKpis: page.binaryKpis,
          shareKpi: page.shareKpi,
          priceKpi: page.priceKpi,
          format: page.format,
          formatDescription: page.formatDescription,
          executor: page.executor || false,
          reviewer: page.reviewer || false,
          userProject: page.userProject || false,
        };

        newQuestionsArray.push(updatedQuestion);
      } else {
        validator = questionValidator(page);
        if (validator !== 0) {
          setSeverity('error');
          switch (validator) {
            case 1:
              setMessage(`${t('task.saveErrors.title')} ${position}`);
              break;
            case 2:
              setMessage(`${t('task.saveErrors.binaryKpis')} ${position}`);
              break;
            default:
              setMessage(`${t('task.saveErrors.questionChoices')} ${position}`);
              break;
          }
          return;
        }

        const baseQuestion = {
          id: page.databaseId,
          identifier: page.identifier,
          surveyId: taskId,
          categoryId: page.categoryId ?? null,
          title: page.title,
          shortQuestion: page.shortQuestion || null,
          description: page.description,
          type: page.type,
          imageKey: page.imageKey,
          imageQuality: page.imageQuality,
          required: page.required,
          deleted: page.deleted,
          emojiScale: page.emojiScale,
          emojiSet: page.emojiSet,
          requiresTeleaudit: page.requiresTeleaudit,
          aiAnalysisRequired: page.aiAnalysisRequired || false,
          imageUrl: page.imageUrl,
          sendEmail: page.sendEmail,
          questionEmails: page.questionEmails,
          position,
          questionLogic: normalizeQuestionLogic(page.questionLogic),
          minMemory:
            page.memoryQuantity && page.memoryUnit
              ? `${page.memoryQuantity} ${page.memoryUnit}`
              : null,
          videoQuality: page.videoQuality || null,
          surveyTeleauditId: page.selectedQuestionOption || null,
          executor: page.executor || false,
          reviewer: page.reviewer || false,
          userProject: page.userProject || false,
        };

        if ([LONG_ANSWER, SHORT_ANSWER].includes(page.type)) {
          newQuestionsArray.push(baseQuestion);
        } else if (
          [IMAGE, MULTIPLE_IMAGE_QUESTION, VIDEO].includes(page.type)
        ) {
          if (page.type !== 'yes') {
            revisionPolicyValidator = 'yes';
          }

          const createdQuestion = {
            ...baseQuestion,
            binaryKpis: page.binaryKpis,
            shareKpi: page.shareKpi,
            priceKpi: page.priceKpi,
          };

          newQuestionsArray.push(createdQuestion);
        } else {
          const createdQuestion = {
            ...baseQuestion,
            // Sin respuesta correcta el estado de la página es [''], que el API
            // interpretaría como índice de opción.
            questionAnswer: page.questionAnswer?.[0] ? page.questionAnswer : null,
            questionChoices: page.questionChoices || null,
            isSwitchStock: page.identifier === switchStock,
          };

          newQuestionsArray.push(createdQuestion);
        }
      }
    });

    // Si alguna pregunta no pasó la validación el payload quedó incompleto:
    // guardarlo así borraría las conexiones de las preguntas que no alcanzaron
    // a armarse.
    if (validator !== 0) return;

    const body = {
      survey: {
        surveyId: taskId,
        title,
        requiredGeoreference: georeference,
        revisionPolicy: revisionPolicyValidator,
        vertical: verticalForm,
        switchStock: values.isSwitchStock,
        productInformation: values.productInformation,
        label: surveyLabel.value,
        surveyTeleauditId: null,
        surveyTeleaudit: isSurveyTeleaudit.value,
        maxDistance: maxDistanceToSave,
        needReview: needReview.value,
        executionSurveyId: executionSurveyId.value,
        reviewSurveyId: reviewSurveyId.value,
        aiAnalysisRequired,
      },
      questions: newQuestionsArray,
      questionsToDelete: deletedQuestions,
    };

    const response = await editSurvey(body);

    if (response.success) {
      await saveQuestionGuidelines();
      history.push(`${taskURLPath}/${taskId}`);
    } else {
      setSeverity('error');
      setMessage(response.message || t('task.saveErrors.generic'));
    }
  };

  const handleViewQuestion = useCallback(
    (event) => {
      const { id } = event.currentTarget;
      if (id === viewDetail) {
        setViewDetail(null);
        return;
      }
      setViewDetail(id);
    },
    [viewDetail],
  );

  const handleOnChangeTitle = useCallback((event) => {
    setTitle(event.target.value);
  }, []);

  useEffect(() => {
    setValues((prev) => ({
      ...prev,
      questions: pages,
    }));
  }, [pages]);

  const handleOpenSettingsDialog = useCallback(() => {
    setOpenSettingsDialog((prev) => !prev);
  }, []);

  const handleDeleteQuestion = useCallback(
    (event) => {
      const { id } = event.currentTarget;
      const deletedPage = pages.find((page) => `${page.identifier}` === `${id}`);

      if (!deletedPage) return;

      // Sólo las preguntas ya guardadas se dan de baja en el API; las nuevas
      // simplemente no viajan en el payload.
      if (deletedPage.databaseId) {
        setDeletedQuestions((prev) => (
          prev.includes(deletedPage.databaseId)
            ? prev
            : [...prev, deletedPage.databaseId]
        ));
      }

      // La pregunta de switch stock se guarda por identificador, así que hay
      // que moverla junto con la renumeración.
      if (switchStock != null) {
        setSwitchStock(remapIdentifierAfterDelete(switchStock, id));
      }

      setPages(removeQuestionAndRewireLogic(pages, id));
    },
    [pages, switchStock],
  );

  const handleDuplicateQuestion = useCallback(
    (event) => {
      const { id } = event.currentTarget;
      const question = pages.find((p) => `${p.identifier}` === `${id}`);

      if (question) {
        const newQuestion = {
          ...question,
          identifier: `${pages.length + 1}`,
          hiddenIdentifier: `${pages.length + 1}`,
          position: `${pages.length + 1}`,
          // La copia va al final y arranca sin conexiones propias, pero con una
          // fila por defecto: el modal de conexiones lee `questionLogic[0]`.
          questionLogic: [
            {
              questionIdentifier: `${pages.length + 1}`,
              questionChoiceIdentifier: null,
              nextQuestionIdentifier: `${pages.length + 2}`,
            },
          ],
          questionChoices: question.questionChoices
            ? question.questionChoices.map((choice) => ({ ...choice }))
            : question.questionChoices,
        };

        delete newQuestion.databaseId;
        if (newQuestion.questionChoices) {
          for (let i = 0; i < newQuestion.questionChoices.length; i += 1) {
            delete newQuestion.questionChoices[i].id;
          }
        }

        setPages([...pages, newQuestion]);
      }
    },
    [pages],
  );

  const handleCreateConnections = useCallback(() => {
    let errors = '';
    pages.forEach((page) => {
      const identifier = page.identifier === 0 ? 1 : page.identifier;
      const validator = questionValidator(page, formType.name);
      if (validator !== 0) {
        setSeverity('error');
        switch (validator) {
          case 1:
            errors += `${t('task.saveErrors.title')} ${identifier}\n`;
            break;
          case 2:
            errors += `${t('task.saveErrors.binaryKpis')} ${identifier}\n`;
            break;
          case 4:
            errors += `${t('task.saveErrors.correctQuestionChoices')} ${identifier}\n`;
            break;
          case 5:
            errors += `${t('task.saveErrors.questionType')} ${identifier}\n`;
            break;
          default:
            errors += `${t('task.saveErrors.questionChoices')} ${identifier}\n`;
            break;
        }
      }
    });

    if (errors === '') {
      setOpenConnections(true);
    } else {
      setMessage(errors);
    }
  }, [pages, formType.name, t]);

  const handleVerticalForm = useCallback(() => {
    // If vertical form is set to true, delete resume page if it exists.
    if (!verticalForm) {
      if (pages.find((p) => p.type === RESUME_PAGE)) {
        handleDeleteQuestion({
          currentTarget: {
            id: pages.find((p) => p.type === RESUME_PAGE).identifier,
          },
        });
      }
    }

    setVerticalForm(!verticalForm);
  }, [verticalForm, pages, handleDeleteQuestion]);

  const handleSwitchStock = useCallback(
    (event) => {
      const { checked } = event.target;

      if (checked) {
        setValues((prev) => ({
          ...prev,
          isSwitchStock: checked,
          productInformation: false,
        }));
      } else {
        // Update page isSwitchStock to false
        const updatedPages = pages.map((page) => ({
          ...page,
          isSwitchStock: false,
        }));
        setPages(updatedPages);
        setSwitchStock(null);
        setValues((prev) => ({
          ...prev,
          isSwitchStock: checked,
        }));
      }
    },
    [pages],
  );

  const handleSwitchProductInformation = useCallback((event) => {
    const { checked } = event.target;

    if (checked) {
      setValues((prev) => ({
        ...prev,
        isSwitchStock: false,
        productInformation: checked,
      }));
    } else {
      setValues((prev) => ({
        ...prev,
        productInformation: checked,
      }));
    }
  }, []);

  return (
    <>
      <div className={styles.content}>
        <div className={styles.headerContainer}>
          <div className={styles.header}>
            <IconButton
              id="backButton"
              aria-label="back"
              className={styles.backButton}
              component={Link}
              to={`${taskURLPath}/${taskId}`}
            >
              <ReplyOutlined fontSize="small" />
              <span>{t('groups.actionButtons.back')}</span>
            </IconButton>
            <TextField
              id="name"
              className={styles.title}
              value={title}
              inputProps={{
                className: styles.title,
                disableUnderline: true,
              }}
              onChange={handleOnChangeTitle}
              fullWidth
            />
            <p>{taskInfo.project ? taskInfo.project.name : null}</p>
          </div>
          <Grid
            container
            spacing={2}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Grid item>
              <div className={styles.buttonsContainer}>
                <Button
                  onClick={handleCreateConnections}
                  disabled={
                    questions.length < 2
                    || (questions.length === 2 && !questions[1].type)
                    || !questions[questions.length - 1].type
                  }
                >
                  {t('task.questionLogic.connections')}
                </Button>
              </div>
            </Grid>
            <Grid item>
              <div className={styles.buttonsContainer}>
                <Button onClick={handleOpenSettingsDialog}>
                  {t('task.taskEdition.settings')}
                </Button>
              </div>
            </Grid>
            <Grid item>
              <div className={styles.buttonsContainer}>
                <Button
                  onClick={handleSaveSurvey}
                  disabled={pages.length === 1 && !pages[0].type}
                >
                  {t('task.taskEdition.save')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
        <Divider />
        <div className={styles.surveyContent}>
          <div className={styles.editionArea}>
            {taskInfo.project === '' && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '300px',
                }}
              >
                <Box sx={{ flexGrow: 'initial !important' }}>
                  <CircularProgress sx={{ color: '#2C9DC9' }} />
                  <p className={styles.loadingText}>{t('loading')}</p>
                </Box>
              </Box>
            )}
            {taskInfo.type !== null && taskInfo.type.name === 'product' && (
              <div>
                <FormControlLabel
                  control={
                    <Switch
                      name="is_switch_stock"
                      className={styles.switch}
                      onChange={handleSwitchStock}
                      checked={values.isSwitchStock}
                      disabled={
                        pages.findIndex((p) => p.type === YES_NO_QUESTION)
                          === -1 || values.productInformation
                      }
                    />
                  }
                  label={t('task.taskEdition.stockSwitch')}
                />
                <FormControlLabel
                  control={
                    <Switch
                      name="product_information"
                      className={styles.switch}
                      onChange={handleSwitchProductInformation}
                      checked={values.productInformation}
                      disabled={values.isSwitchStock}
                    />
                  }
                  label={t('task.taskEdition.productInformationSwitch')}
                />
              </div>
            )}
            <CategoryOptionsProvider>
              <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable-list">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {pages.map((page, index) => (
                      <Draggable
                        draggableId={`${index}`}
                        index={index}
                        key={index}
                      >
                        {(prov) => (
                          <div
                            id={`${page.type}-${index}`}
                            onClick={handleSelectPage}
                            ref={prov.innerRef}
                            {...prov.draggableProps}
                            {...prov.dragHandleProps}
                          >
                            <ExpandLess
                              className={clsx(styles.hideContent, {
                                [styles.selectedPageArrows]:
                                  selectedPage === `${index}`
                                  && generalView
                                  && !(viewDetail === `${index}`),
                              })}
                            />
                            <div
                              className={clsx(styles.pageInfo, {
                                [styles.selectedPageGeneralView]:
                                  selectedPage === `${index}`
                                  && generalView
                                  && !(viewDetail === `${index}`),
                                [styles.generalViewPageTitle]:
                                  generalView && !(viewDetail === `${index}`),
                              })}
                            >
                              <div>
                                {generalView && <DragIndicator />}
                                <p className={styles.pageTitle}>
                                  {t('task.taskEdition.page')} {index + 1}
                                  {page.type ? `: ${page.name}` : ''}
                                </p>
                                {page.databaseId && (
                                  <p className={styles.pageTitle}>
                                    ID: {page.databaseId}
                                  </p>
                                )}
                              </div>
                              <div>
                                {page.type && generalView ? (
                                  <>
                                    <Edit fontSize="small" />
                                    <Button
                                      id={index}
                                      onClick={handleViewQuestion}
                                    >
                                      <VisibilityOutlined
                                        className={styles.viewQuestion}
                                      />
                                    </Button>
                                  </>
                                ) : null}
                                {page.type
                                && !generalView
                                && ![
                                  WELCOME_PAGE,
                                  END_PAGE,
                                  CONTENT,
                                  RESUME_PAGE,
                                ].includes(page.type) ? (
                                  <>
                                    <p className={styles.pageTitle}>
                                      {t('task.taskEdition.obligatory')}
                                    </p>
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          name={`${index}`}
                                          className={styles.switch}
                                          onChange={handleSwitch}
                                          checked={page.required}
                                        />
                                      }
                                      label=""
                                    />
                                  </>
                                  ) : null}
                              </div>
                            </div>
                            <ExpandMore
                              className={clsx(styles.hideContent, {
                                [styles.selectedPageArrows]:
                                  selectedPage === `${index}`
                                  && generalView
                                  && !(viewDetail === `${index}`),
                              })}
                            />
                            <div
                              className={clsx({
                                [styles.selectedPageStyle]:
                                  selectedPage === `${index}`,
                                [styles.hideContent]:
                                  generalView && !(viewDetail === `${index}`),
                              })}
                            >
                              {[WELCOME_PAGE, END_PAGE, CONTENT].includes(
                                page.type,
                              ) && (
                                <WelcomePage
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                />
                              )}
                              {page.type === RESUME_PAGE && (
                                <ResumePage
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                />
                              )}
                              {page.type === SIMPLE_SELECTION && (
                                <SimpleSelection
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  setPages={setPages}
                                />
                              )}
                              {page.type === USER_SELECTION && (
                                <UserSelection
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  setPages={setPages}
                                />
                              )}
                              {page.type === MULTIPLE_SELECTION && (
                                <MultipleSelection
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  setPages={setPages}
                                />
                              )}
                              {page.type === SHORT_ANSWER && (
                                <ShortAnswer
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  deletedQuestions={deletedQuestions}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  setPages={setPages}
                                />
                              )}
                              {page.type === LONG_ANSWER && (
                                <LongAnswer
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  setPages={setPages}
                                />
                              )}
                              {page.type === FORMATTED_ANSWER && (
                                <FormattedAnswer
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  setPages={setPages}
                                />
                              )}
                              {page.type === DROP_DOWN_MENU && (
                                <DropDownMenu
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  setPages={setPages}
                                />
                              )}
                              {page.type === SATISFACTION && (
                                <Satisfaction
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  editMode={true}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                />
                              )}
                              {page.type === IMAGE && (
                                <ImagesAnswer
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  questionOptions={teleauditQuestionOptions}
                                  surveyAiAnalysisRequired={aiAnalysisRequired}
                                />
                              )}
                              {page.type === YES_NO_QUESTION && (
                                <YesNoQuestion
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  switchStock={switchStock}
                                  setSwitchStock={setSwitchStock}
                                  isSwitchStock={values.isSwitchStock}
                                />
                              )}
                              {page.type === DATE && (
                                <DateAnswer
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  setPages={setPages}
                                />
                              )}
                              {page.type === NUMERIC_ANSWER && (
                                <NumericAnswer
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  setPages={setPages}
                                />
                              )}
                              {page.type === DECIMAL_ANSWER && (
                                <DecimalAnswer
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  setPages={setPages}
                                />
                              )}
                              {page.type === NPS_QUESTION && (
                                <NpsQuestion
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                />
                              )}
                              {page.type === MULTIPLE_IMAGE_QUESTION && (
                                <MultipleImageQuestion
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  questionOptions={teleauditQuestionOptions}
                                  surveyAiAnalysisRequired={aiAnalysisRequired}
                                />
                              )}
                              {page.type === SIGNATURE_QUESTION && (
                                <SignatureQuestion
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                />
                              )}
                              {page.type === BARCODE_QUESTION && (
                                <BarcodeQuestion
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                />
                              )}
                              {page.type === TIME && (
                                <Time
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                />
                              )}
                              {page.type === PRICE && (
                                <Price
                                  identifier={page.identifier}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                />
                              )}
                              {page.type === VIDEO && (
                                <Video
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                  questionOptions={teleauditQuestionOptions}
                                />
                              )}
                              {([AUDIO, AUDIO_BACKGROUND].includes(page.type)) && (
                                <Audio
                                  identifier={page.identifier}
                                  mode={EDIT_MODE}
                                  pages={pages}
                                  formType={formType}
                                  handleDeleteQuestion={handleDeleteQuestion}
                                  handleDuplicateQuestion={
                                    handleDuplicateQuestion
                                  }
                                />
                              )}
                              {!page.type && (
                                <SelectPage
                                  setPages={setPages}
                                  pages={pages}
                                  mode={EDIT_MODE}
                                  formType={formType}
                                  identifier={page.identifier}
                                  setSwitchStock={setSwitchStock}
                                  verticalForm={verticalForm}
                                />
                              )}
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            </CategoryOptionsProvider>
            <Button className={styles.button} onClick={handleAddSection}>
              {t('task.taskEdition.addPageButton')}
            </Button>
          </div>
        </div>
        {openConnections && (
          <QuestionLogic
            open={openConnections}
            setOpen={setOpenConnections}
            inputValues={pages}
            setInputValues={setPages}
            edit={true}
            view={false}
          />
        )}
        {openSettingsDialog && (
          <TaskSettings
            open={openSettingsDialog}
            setOpen={setOpenSettingsDialog}
            georeference={georeference}
            setGeoreference={setGeoreference}
            aiAnalysisRequired={aiAnalysisRequired}
            setAiAnalysisRequired={setAiAnalysisRequired}
            revisionPolicy={revisionPolicy}
            setRevisionPolicy={setRevisionPolicy}
            isSurveyTeleaudit={isSurveyTeleaudit}
            setIsSurveyTeleaudit={setIsSurveyTeleaudit}
            verticalForm={verticalForm}
            handleVerticalForm={handleVerticalForm}
            surveyLabel={surveyLabel}
            setSurveyLabel={setSurveyLabel}
            formType={taskInfo.type}
            maxDistance={maxDistance}
            setMaxDistance={setMaxDistance}
            needReview={needReview}
            setNeedReview={setNeedReview}
            executionSurveyId={executionSurveyId}
            setExecutionSurveyId={setExecutionSurveyId}
            reviewSurveyId={reviewSurveyId}
            setReviewSurveyId={setReviewSurveyId}
            executionSurveyOptions={executionSurveyOptions}
            reviewSurveyOptions={reviewSurveyOptions}
          />
        )}
        <Snackbar
          open={message !== ''}
          message={message}
          severity={severity}
          onClose={() => setMessage('')}
        />
      </div>
    </>
  );
}

export default TaskEdit;
